<div class="routine-workspace-header">
	<div class="header-row">
		<entity-title
			entityType="routine"
			[name]="config()?.name"
			(nameChanged)="updateData($event)"
		/>
		<au-close-button (closeCallback)="closeSidebar()" />
	</div>
	<div class="sub-header">
		<div class="font-title-medium">
			{{ routineType() | translate }}
		</div>
		@if (canEditTemplate()) {
			<entity-workspace-actions
				[config]="{ data: config() }"
				[isRoutineTemplate]="true"
				[actionsForDisplay]="['editTitle', 'delete']"
			/>
		}
	</div>
</div>

<mat-tab-group class="fill-tab-height">
	<mat-tab [label]="'information' | translate">
		<routine-information-tab
			class="tab-padding"
			[config]="config()"
			[canEditTemplate]="canEditTemplate()"
			(updateData)="updateData($event)"
		/>
	</mat-tab>
	<mat-tab [label]="'tasks' | translate">
		<routine-tasks-tab
			class="tab-padding"
			[template]="config().template"
			[canEditTemplate]="canEditTemplate()"
			(updateData)="updateData($event)"
		/>
	</mat-tab>
</mat-tab-group>
